module.exports = __webpack_public_path__ + "img/kv_bg.c89a2d6b.jpg";